import { HttpHeaders } from '@angular/common/http';

export class HttpOptions {
  headers: HttpHeaders;
}
